import { render, staticRenderFns } from "./patient-details.vue?vue&type=template&id=7b3c95b2&scoped=true"
import script from "./patient-details.vue?vue&type=script&lang=js"
export * from "./patient-details.vue?vue&type=script&lang=js"
import style0 from "./patient-details.vue?vue&type=style&index=0&id=7b3c95b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c95b2",
  null
  
)

export default component.exports